import React, { useState, useEffect, useRef } from 'react';
import axios from '../../axiosConfig';
import { Form, Button, Modal, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import SelectComponent from '../../components/SelectComponent';
import { useLoading } from '../../components/LoadingContext';
import { ToastContainer, toast } from 'react-toastify';
import { Card, Row, Col } from 'react-bootstrap'; 
import { FaSearch } from 'react-icons/fa';  // Importamos íconos de react-icons




const CreateCursos = () => {
  const { setLoading } = useLoading();
  const [selectedUserName, setSelectedUserName] = useState(''); // Nombre del usuario seleccionado
  const [showRoleSearchModal, setShowRoleSearchModal] = useState(false);  // Modal de búsqueda de roles
  const [roles, setRoles] = useState([]);  // Lista de roles
  const [selectedRoleId, setSelectedRoleId] = useState(null);  // ID del rol seleccionado
  const [selectedRoleName, setSelectedRoleName] = useState('');  // Nombre del rol seleccionado
  const [filteredRoles, setFilteredRoles] = useState([]);
  const [searchRoleName, setSearchRoleName] = useState(''); // Estado específico para la búsqueda de roles
  const [showConfirmModal, setShowConfirmModal] = useState(false);  
  const [showUserRoleModal, setShowUserRoleModal] = useState(false); 
  const [showUserSearchModal, setShowUserSearchModal] = useState(false);  // Modal de búsqueda de usuarios
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [comentario, setComentario] = useState('');  // Nuevo estado para el comentario

  const [paginatedUsers, setPaginatedUsers] = useState([]); // Usuarios en la página actual
  const [currentPageUsers, setCurrentPageUsers] = useState(1);
  
  const [paginatedRoles, setPaginatedRoles] = useState([]); // Roles en la página actual
  const [currentPageRoles, setCurrentPageRoles] = useState(1);
  const [totalPages, setTotalPages] = useState(1); // Default to 1 page initially
   const [currentPageCursos, setCurrentPageCursos] = useState(1);
      const [paginatedCursos, setPaginatedCursos] = useState([]); // Usuarios en la página actual
      const [showCursoModal, setShowCursoModal] = useState(false);
          const [curso, setCurso] = useState(null);
                  const userRole = localStorage.getItem('role');

      const userId = parseInt(localStorage.getItem('user'));  // ID del usuario logueado   
      
  
  const itemsPerPage = 8; // Elementos por página

  const [formData, setFormData] = useState({
    descripcion: '',
    cantidad_horas: '',
    area_id: '',
    unidad_id:'',
    nivel_id:'',
    modalidad_id:'',
    sesiones:0,
    grupo:'',
    externo:false,
    area2_id:'',
    area3_id:'',
    area4_id:'',
    area5_id:'',
    activo:true,
    duracion:'',
    categoria_prog_id:'',
    audiencia:'',
    prelacion_id:'',
    virtual_modo_id:'',
    
  });

  const [filtrosCurso, setFiltrosCurso] = useState({
      area_id: '',
      modalidad_id: '',
      nivel_id: '',
      tipo_programa_id: '',
      unidad_id:'',
      cod:'',
      grupo:'',
      curso_descripcion:'',
      activo:true,
  });

  const [filterOptions, setFilterOptions] = useState({
    areaOptions: [],
    unidadOptions: [],
    nivelOptions: [],
    modalidadOptions: [],
    grupoOptions: [],
    categoriaOptions:[],
    virtualOptions:[],
});
  const navigate = useNavigate();
  const [selectVisible, setSelectVisible] = useState(false);  // Control de la visibilidad de los selectores


  useEffect(() => {
    handleSeleccionar();
    const fetchSelectData = async () => {
      setLoading(true); // Inicia la animación de carga
    };
    if (showUserSearchModal) {
      getAllUsers();
    } else if (showRoleSearchModal) {
      getAllRoles();
    }
  }, [showUserSearchModal, showRoleSearchModal]);
  const [filters, setFilters] = useState({
    username:'',
    name:''
  });

  const getAllUsers = async (page = 1) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`/users-paginate`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { ...filters, page }, // Incluye `page` en los parámetros
        });

        const { data, last_page, current_page } = response.data.users;

        // Actualizar el estado
        setPaginatedUsers(data); // Datos de la página actual
        setCurrentPageUsers(current_page); // Página actual
        setTotalPages(last_page); // Total de páginas
    } catch (error) {
        console.error('Error fetching users:', error);
        toast.error('Error fetching data');
        setPaginatedUsers([]); // Limpia los datos en caso de error
    }
};

const getAllRoles = async (page = 1) => {
  try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`/role-paginate`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { ...filters, page }, // Incluye `page` en los parámetros
      });

      const { data, last_page, current_page } = response.data.roles;

      setPaginatedRoles(data); // Datos de la página actual
      setCurrentPageRoles(current_page); // Página actual
      setTotalPages(last_page); // Total de páginas
  } catch (error) {
      console.error('Error fetching roles:', error);
      toast.error('Error fetching data');
      setPaginatedRoles([]); // Limpia los datos en caso de error
  }
};

const handleFilterCursoChange = (e) => {
        const { name, value } = e.target;
        setFiltrosCurso(prev => ({ ...prev, [name]: value }));
      };
       const handleOpenCursoModal = () => {
        getAllCursos(currentPageCursos);  // Obtener los cursos de la página actual
        setShowCursoModal(true);   // Mostrar el modal de cursos
    };
    
      
      
      const handleCursosPageChange = async (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            await getAllCursos(newPage);
        }
      };

       const handleSeleccionarCurso = (cursoSeleccionado) => {
        console.log("Curso seleccionado: ", cursoSeleccionado);  // Verifica si se selecciona correctamente
        setCurso(cursoSeleccionado); // Guardar el curso seleccionado en el estado
        setFormData(prevData => ({
            ...prevData,
            prelacion_id: cursoSeleccionado.curso_id,  // Almacenar el ID del curso seleccionado
        }));
        console.log("id del curso es: ", cursoSeleccionado.curso_id)
        setShowCursoModal(false); // Cerrar el modal
    };


const handleFilterChange = (e) => {
  const { name, value } = e.target;
  setFilters(prev => ({ ...prev, [name]: value }));
};


const handleUserPageChange = async (newPage) => {
  if (newPage >= 1 && newPage <= totalPages) {
      await getAllUsers(newPage);
  }
};

const handleRolePageChange = async (newPage) => {
  if (newPage >= 1 && newPage <= totalPages) {
      await getAllRoles(newPage);
  }
};

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

const handleConfirmSendRequest = async () => {
    try {
      let dataToSend = { ...formData, status:false }; // Inicia dataToSend con los datos del formulario
  
      const token = localStorage.getItem('token');
    
      // 1. Crear el nuevo curso primero
      const response = await axios.post(`/cursos`, dataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    
      const newCursoId = response.data.id;  // Obtener el ID del nuevo participante
    
      // 2. Usar el ID del nuevo participante como clave en la petición
      const requestData = {
        user_id: userId,  // Usuario logueado que envía la solicitud
        destinatario_id: selectedUserId || null,  // Usuario destinatario seleccionado (si existe)
        role_id: selectedRoleId || null,  // El role_id es nulo si se seleccionó un usuario, si no, el rol seleccionado
        zona_id: 15,  // Valor fijo
        status: false,  // Estado de la petición
        finish_time: null,  // No hay finish_time al momento de creación
        key: newCursoId,  // Usar el ID del nuevo participante como clave
        comentario: comentario,
      };
    
      // 3. Enviar la petición
      await axios.post(`/peticiones`, requestData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      toast.success("Nuevo Curso agregado y petición creada con Éxito");
      
        navigate('/cursos'); // Redirige a la página de datos
     
    } catch (error) {
      toast.error('Error al enviar la solicitud o los datos');
      console.error('Error al enviar la solicitud o los datos:', error);
    }
  };
  

    const handleSubmit = async (e) => {
      e.preventDefault(); // Previene el comportamiento por defecto del formulario
    
        if (userRole!=='admin') {
        setShowConfirmModal(true);
        setLoading(false);
        return;
      }

         setLoading(true); // Inicia el proceso de carga
      const dataToSend = {
        ...formData,
        status:true,
      };
    
      try {
        const token = localStorage.getItem('token'); // Obtiene el token del localStorage
    
        if (!token) {
          toast.error('Error: Token no encontrado');
          setLoading(false);
          return;
        }
    
        // Envía los datos del formulario al backend
        await axios.post(`/cursos`, dataToSend, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
    
        toast.success('Nuevo Curso agregado con Éxito');
    
     
          navigate('/cursos');
        
    
      } catch (error) {
        toast.error('Error al crear Curso');
        console.error('Error creating data:', error);
      } finally {
        setLoading(false); // Detiene el proceso de carga
      }
    };


const handleSeleccionar = async () => {
  try {
    const token = localStorage.getItem('token');
    
    // Suponiendo que el endpoint unificado sea `/filtros-cursos`
    const response = await axios.get(`/filtros-cursos`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    
    // Desestructuramos los datos que vienen en la respuesta
    const { area, unidad, nivel, modalidad,grupo,categoriaProg ,virtualmodo} = response.data;

    // Retornamos las opciones en un solo objeto
    setFilterOptions( {
      areaOptions: area,
      unidadOptions: unidad,
      nivelOptions: nivel,
      modalidadOptions: modalidad,
      grupoOptions:grupo,
      categoriaOptions:categoriaProg,
      virtualOptions:virtualmodo,
    });

  } catch (error) {
    console.error('Error fetching filter options:', error);
    
  }
};

const getAllCursos = async (page = 1) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/cursos-paginate`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { ...filtrosCurso, page }, // Incluye `page` en los parámetros
            });
    
            const { data, last_page, current_page } = response.data.cursos;
    
            // Actualizar el estado
            setPaginatedCursos(data); // Datos de la página actual
            setCurrentPageCursos(current_page); // Página actual
            setTotalPages(last_page); // Total de páginas
        } catch (error) {
            console.error('Error fetching users:', error);
            toast.error('Error fetching data');
            setPaginatedCursos([]); // Limpia los datos en caso de error
        }
    };


  const handleSelectUser = (user) => {
    setSelectedUserId(user.id);
    setSelectedUserName(user.username);
    setSelectedRoleId(null); // Limpiar selección de rol al seleccionar usuario
    setSelectedRoleName('');
    setShowUserSearchModal(false);
    setShowConfirmModal(true);
  };

  const handleSelectRole = (role) => {
    setSelectedRoleId(role.id);
    setSelectedRoleName(role.name);
    setSelectedUserId(null); // Limpiar selección de usuario al seleccionar rol
    setSelectedUserName('');
    setShowRoleSearchModal(false);
    setShowConfirmModal(true);
  };


  // Al elegir el tipo de programa se SUGIERE la carga horaria habitual, pero
  // se puede cambiar. Antes `cantidad_horas` estaba en las dependencias de
  // este efecto: cualquier numero que se escribiera se revertia a 2 o 4 en el
  // acto, asi que un programa de tipo 1 no admitia otra cosa que 2 horas.
  const tipoProgramaPrevio = useRef(formData.unidad_id);
  useEffect(() => {
    // Al montar no se toca: en edicion pisaria las horas ya guardadas.
    if (tipoProgramaPrevio.current === formData.unidad_id) return;
    tipoProgramaPrevio.current = formData.unidad_id;

    const horasSugeridas = { "1": 2, "2": 4 }[formData.unidad_id];
    if (horasSugeridas) {
      setFormData((prevState) => ({
        ...prevState,
        cantidad_horas: horasSugeridas,
        sesiones: 1,
      }));
    }
  }, [formData.unidad_id]);

  // En el tipo 3 las sesiones si se derivan de las horas, cada vez que cambian.
  useEffect(() => {
    if (formData.unidad_id !== "3") return;
    setFormData((prevState) => ({
      ...prevState,
      sesiones: prevState.cantidad_horas
        ? Math.floor(prevState.cantidad_horas / 4)
        : "",
    }));
  }, [formData.unidad_id, formData.cantidad_horas]);
  

  return (
    <div className="row" style={{ marginTop: '50px' }}>
  <div className="col-lg-6 mx-auto"> {/* Centrado del contenido */}
    <div className="card-box" style={{ padding: '20px', width: '100%', margin: '0 auto' }}>
      <h2 className="mb-2">Agregar Nueva Unidad Curricular</h2>
      <Form onSubmit={handleSubmit} className="custom-gutter">
        <Form.Group controlId="externo">
              <Form.Label>¿Programa Externo?</Form.Label>
              <Form.Control
                  as="select"
                  name="externo"
                  value={formData.externo} // Asume que formData tiene la clave curso_externo
                  onChange={handleChange}
              >
                  <option value="">Seleccione</option>
                  <option value="true">Si</option>
                  <option value="false">No</option>
              </Form.Control>
          </Form.Group>
      <Form.Group controlId="activo">
        <Form.Label>Status de Programa</Form.Label>
        <Form.Control
            as="select"
            name="activo"
            value={formData.activo} // Asume que formData tiene la clave curso_externo
            onChange={handleChange}
            required
        >
            <option value="">Seleccione</option>
            <option value="true">Activo</option>
            <option value="false">Inactivo</option>
        </Form.Control>
    </Form.Group>

      <Form.Group controlId="descripcion">
              <Form.Label>Nombre del Programa</Form.Label>
              <Form.Control
                type="text"
                name="descripcion"
                maxLength={255}
                value={formData.descripcion}
                onChange={handleChange}
                required
              />
            </Form.Group>
              <SelectComponent
              options={filterOptions.modalidadOptions}  // Usar el estado filterOptions

              nameField="descripcion"
              valueField="id"
              selectedValue={formData.modalidad_id}
              handleChange={handleChange}
              controlId="modalidad_id"
              label="Modalidad"
            />
             {(formData.modalidad_id === '3' || formData.modalidad_id === 3) ? (
                <SelectComponent
                  options={filterOptions.virtualOptions}  // Usar el estado filterOptions
                  nameField="descripcion"
                  valueField="id"
                  selectedValue={formData.virtual_modo_id}
                  handleChange={handleChange}
                  controlId="virtual_modo_id"
                  label="Modo Virtual"
                />
              ) : (
                <SelectComponent
                  options={filterOptions.unidadOptions}  // Usar el estado filterOptions
                  nameField="descripcion"
                  valueField="id"
                  selectedValue={formData.unidad_id}
                  handleChange={handleChange}
                  controlId="unidad_id"
                  label="Unidad"
                />
              )}

             {/* <SelectComponent
                        options={filterOptions.grupoOptions}  // Usar el estado filterOptions
                        nameField="descripcion"
                        valueField="id"
                        insertValueField="descripcion"
                        selectedValue={formData.grupo}
                        handleChange={handleChange}
                        controlId="grupo"
                        label="grupo"
                        required
                    /> */}

          <Row className="g-2">
          <Col md={6}>
            <Form.Group controlId="cantidad_horas">
              <Form.Label>Cantidad de Horas</Form.Label>
              <Form.Control
                type="number"
                name="cantidad_horas"
                value={formData.cantidad_horas}
                onChange={handleChange}
                maxLength={4}
                // disabled={formData.unidad_id === "1" || formData.unidad_id === "2"} // Bloquear si tipo_programa_id es 1 o 2
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group controlId="sesiones">
              <Form.Label>Cantidad de Sesiones</Form.Label>
              <Form.Control
                type="number"
                name="sesiones"
                value={formData.sesiones}
                onChange={handleChange}
                maxLength={4}
                // disabled={formData.unidad_id !== "3"} // Bloquear si tipo_programa_id no es 3
              />
            </Form.Group>
          </Col>

          </Row>
           {/* <Form.Group controlId="duracion">
              <Form.Label>Duraciòn</Form.Label>
              <Form.Control
                type="text"
                name="duracion"
                value={formData.duracion}
                onChange={handleChange}
                maxLength={100}
                required
              />
            </Form.Group> */}
          <Row className="g-2">
         
          <SelectComponent
              
              options={filterOptions.areaOptions}  // Usar el estado filterOptions
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.area_id}
              handleChange={handleChange}
              controlId="area_id"
              label="Área"
            />
            
            <Col md={6}>
             {/* <SelectComponent
              
              options={filterOptions.categoriaOptions}  // Usar el estado filterOptions
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.categoria_prog_id}
              handleChange={handleChange}
              controlId="categoria_prog_id"
              label="Categoria"
            /> */}
            
            </Col>
          
          </Row>
          {(formData.unidad_id === '4' || formData.unidad_id === 4) && (
            <>
            <SelectComponent
                
                options={filterOptions.areaOptions}  // Usar el estado filterOptions
                nameField="descripcion"
                valueField="id"
                selectedValue={formData.area2_id}
                handleChange={handleChange}
                controlId="area2_id"
                label="Área 2"
              />
          

              <SelectComponent
                
                options={filterOptions.areaOptions}  // Usar el estado filterOptions
                nameField="descripcion"
                valueField="id"
                selectedValue={formData.area3_id}
                handleChange={handleChange}
                controlId="area3_id"
                label="Área 3"
              />
                <SelectComponent
                
                options={filterOptions.areaOptions}  // Usar el estado filterOptions
                nameField="descripcion"
                valueField="id"
                selectedValue={formData.area4_id}
                handleChange={handleChange}
                controlId="area4_id"
                label="Área 4"
              />
              <SelectComponent
                
                options={filterOptions.areaOptions}  // Usar el estado filterOptions
                nameField="descripcion"
                valueField="id"
                selectedValue={formData.area5_id}
                handleChange={handleChange}
                controlId="area5_id"
                label="Área 5"
              />
              </>

            )}

          
        
         
          <SelectComponent
              options={filterOptions.nivelOptions}  // Usar el estado filterOptions
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.nivel_id}
              handleChange={handleChange}
              controlId="nivel_id"
              label="Nivel"
            />
        
        {/* <Form.Group controlId="audiencia">
              <Form.Label>Audiencia</Form.Label>
              <Form.Control
                type="text"
                name="audiencia"
                value={formData.audiencia}
                onChange={handleChange}
                maxLength={255}
                required
              />
            </Form.Group> */}

            {/* <Form.Group controlId="curso">
                <Form.Label>Prelacion</Form.Label>
                <div className="d-flex">
                    {curso ? (
                        <>
                            <Form.Control 
                                type="text" 
                                value={curso.curso_descripcion} 
                                readOnly 
                            />
                            <Button variant="secondary" onClick={handleOpenCursoModal} className="ms-2">
                                Cambiar
                            </Button>
                        </>
                    ) : (
                        <Button variant="info" onClick={handleOpenCursoModal}>
                            Seleccionar Unidad Curricular
                        </Button>
                    )}
                </div>
                
            </Form.Group> */}
        
        {/* <Form.Group controlId="fecha_inicio">
              <Form.Label>Fecha de Inicio</Form.Label>
              <Form.Control
                type="date"
                name="fecha_inicio"
                value={formData.fecha_inicio}
                onChange={handleChange}
              />
            </Form.Group> */}


        <div className="d-flex justify-content-end mt-3">
          <Button variant="secondary" onClick={() => navigate('/cursos')} className="me-2">
            Volver
          </Button>
          <Button variant="success" type="submit">
            Guardar
          </Button>
        </div>
      </Form>
 


      
            {/* Modal para seleccionar usuario o rol */}
            <Modal show={showConfirmModal && !selectedUserId && !selectedRoleId} onHide={() => setShowConfirmModal(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Enviar Petición</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                Seleccione si desea enviar la petición de Confirmación a un Rol o Usuario en especifico
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowUserRoleModal(false)}>
                  Cancelar
                </Button>
                <Button variant="warning" onClick={() => {
                  setShowUserRoleModal(false);
                  setShowUserSearchModal(true);
                }}>
                  Buscar Usuario
                </Button>
                <Button variant="info" onClick={() => {
                  setShowUserRoleModal(false);
                  setShowRoleSearchModal(true);
                }}>
                  Buscar Rol
                </Button>
              </Modal.Footer>
            </Modal>
      
            {/* Modal de búsqueda de usuarios */}
            <Modal show={showUserSearchModal} onHide={() => setShowUserSearchModal(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Buscar Usuario</Modal.Title>
              </Modal.Header>
              <Modal.Body>
              <div className="d-flex align-items-center">
                <Form.Control
                  name="username"
                  type="text"
                  placeholder="Buscar por nombre"
                  value={filters.username}
                  onChange={handleFilterChange}
                  className="me-2"
                />
                <Button 
                    variant="info me-2" 
                    onClick={getAllUsers}
                    style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
                >
                    <FaSearch className="me-1" /> {/* Ícono de lupa */}
                </Button>
                </div>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Nombre</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedUsers.length > 0 ? (
                        paginatedUsers.map(user => (
                            <tr key={user.id}>
                                <td>{user.id}</td>
                                <td>{user.username}</td>
                                <td>
                                <div className="d-flex justify-content-center align-items-center">
      
                                      <Button variant="info" onClick={() => handleSelectUser(user)} className="me-2">
                                          <i className="bi bi-check2-square"></i>
                                      </Button>
                                  </div>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="3">No se encontraron usuarios.</td>
                        </tr>
                    )}
                </tbody>
      
                </Table>
                <div className="d-flex justify-content-between mt-3">
                <Button
                  variant="secondary"
                    onClick={() => handleUserPageChange(currentPageUsers - 1)}
                    disabled={currentPageUsers === 1}
                >
                    Anterior
                </Button>
                
                <Button
                    variant="secondary"
                    onClick={() => handleUserPageChange(currentPageUsers + 1)}
                    disabled={currentPageUsers === totalPages}
                >
                    Siguiente
                </Button>
                
      
      
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowUserSearchModal(false)}>
                  Cerrar
                </Button>
                <Button variant="light" onClick={() => {
                  setShowUserSearchModal(false);
                  setShowUserRoleModal(true);
                }}>
                  Volver
                </Button>
              </Modal.Footer>
            </Modal>
      
            {/* Modal de búsqueda de roles */}
            <Modal show={showRoleSearchModal} onHide={() => setShowRoleSearchModal(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Buscar Rol</Modal.Title>
              </Modal.Header>
              <Modal.Body>
              <div className="d-flex align-items-center">
                <Form.Control
                  name="name"
                  type="text"
                  placeholder="Buscar por nombre"
                  value={filters.name}
                  onChange={handleFilterChange}
                  className="me-2" // Margen derecho para separar del botón
                  style={{ flex: 1 }} // Ajusta el ancho para que ocupe el espacio disponible
                />
                <Button
                  variant="info"
                  onClick={getAllRoles}
                  style={{ whiteSpace: 'nowrap' }} // Evita que el texto del botón se rompa en varias líneas
                >
                  <FaSearch className="me-1" /> Buscar {/* Ícono de lupa */}
                </Button>
              </div>
      
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Nombre</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                  {paginatedRoles.length > 0 ? (
                      paginatedRoles.map(role => (
                          <tr key={role.id}>
                              <td>{role.id}</td>
                              <td>{role.name}</td>
                              <td>
      
                                  <div className="d-flex justify-content-center align-items-center">
      
                                    <Button variant="info" onClick={() => handleSelectRole(role)} className="me-2">
                                        <i className="bi bi-check2-square"></i>
                                    </Button>
                                  </div>
                              </td>
                          </tr>
                      ))
                  ) : (
                      <tr>
                          <td colSpan="3">No se encontraron roles.</td>
                      </tr>
                  )}
              </tbody>
      
                </Table>
                <div className="d-flex justify-content-between mt-3">
                <Button
                  variant="secondary"
                  onClick={() => handleRolePageChange(currentPageRoles - 1)}
                  disabled={currentPageRoles === 1}
              >
                  Anterior
              </Button>
               
                    <Button
                        variant="secondary"
                        onClick={() => handleRolePageChange(currentPageRoles + 1)}
                        disabled={currentPageRoles === totalPages}
                    >
                        Siguiente
                    </Button>
                 
      
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowRoleSearchModal(false)}>
                  Cerrar
                </Button>
                <Button variant="light" onClick={() => {
                  setShowRoleSearchModal(false);
                  setShowUserRoleModal(true);
                }}>
                  Volver
                </Button>
              </Modal.Footer>
            </Modal>
      
      
            {/* Modal de confirmación para enviar la solicitud al usuario */}
            <Modal show={selectedUserId !== null && showConfirmModal} onHide={() => setShowConfirmModal(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Confirmar Envío de Solicitud</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {selectedUserId
                  ? `¿Seguro que deseas enviar la solicitud al usuario ${selectedUserName}?`
                  : 'No se ha seleccionado ningún usuario.'}
              </Modal.Body>
              <Form.Group controlId="comentario" style={{ margin: '10px 20px' }}>
                <Form.Label>Comentario (opcional)</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Agrega un comentario sobre lo que hiciste o lo que falta."
                  value={comentario}
                  onChange={(e) => setComentario(e.target.value)}
                  style={{ padding: '5px', resize: 'none' }}
                />
              </Form.Group>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>Cancelar</Button>
                <Button variant="success" onClick={handleConfirmSendRequest} disabled={!selectedUserId}>Confirmar</Button>
                <Button variant="light" onClick={() => {
                  setShowConfirmModal(false);
                  setShowUserSearchModal(true);
                }}>
                  Volver
                </Button>
              </Modal.Footer>
            </Modal>
      
            {/* Modal de confirmación para enviar la solicitud al rol */}
            <Modal show={selectedRoleId !== null && showConfirmModal} onHide={() => setShowConfirmModal(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Confirmar Envío de Solicitud</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {selectedRoleId
                  ? <p>¿Seguro que deseas enviar la solicitud al rol {selectedRoleName}?</p>
                  : <p>No se ha seleccionado ningún rol.</p>}
                <Form.Group controlId="comentario" style={{ margin: '10px 0' }}>
                  <Form.Label>Comentario (opcional)</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Agrega un comentario sobre lo que hiciste o lo que falta."
                    value={comentario}
                    onChange={(e) => setComentario(e.target.value)}
                    style={{ padding: '5px', resize: 'none' }}
                  />
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>Cancelar</Button>
                <Button variant="success" onClick={handleConfirmSendRequest} disabled={!selectedRoleId}>Confirmar</Button>
                <Button variant="light" onClick={() => {
                  setShowConfirmModal(false);
                  setShowRoleSearchModal(true);
                }}>Volver</Button>
              </Modal.Footer>
            </Modal>


      <Modal show={showCursoModal} onHide={() => setShowCursoModal(false)} size="lg">
          <Modal.Header closeButton>
              <Modal.Title>Seleccionar U.C de Prelacion</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <Row className="mb-3 mt-3">
          <Col>
          <div className="d-flex align-items-center">
                  <Form.Control 
                      name= "cod"
                      type="text" 
                      placeholder="Buscar por Código (COD)" 
                      value={filtrosCurso.cod} 
                      onChange={handleFilterCursoChange} 
                  />
                  <Button 
                      variant="info me-2" 
                      onClick={getAllCursos}
                      style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
                  >
                      <FaSearch className="me-1" /> {/* Ícono de lupa */}
                  </Button>
              </div>
          </Col>
      </Row>
      <Row>
      <Form.Control 
              name= "curso_descripcion"
              type="text" 
              placeholder="Buscar por Nombre" 
              value={filtrosCurso.curso_descripcion} 
              onChange={handleFilterCursoChange} 
          />
      </Row>

              <Row>
                  <Col>
                      <Form.Select 
                      name='area_id'
                      value={filtrosCurso.area_id}
                      onChange={(e) => setFiltrosCurso({ ...filtrosCurso, area_id: e.target.value })}>
                          <option value="">Filtrar por Área</option>
                          {filterOptions.areaOptions.map(area => (
                              <option key={area.id} value={area.id}>{area.descripcion}</option>
                          ))}
                      </Form.Select>
                  </Col>
                  <Col>
                      <Form.Select
                      name='unidad_id'
                      value={filtrosCurso.unidad_id}
                        onChange={(e) => setFiltrosCurso({ ...filtrosCurso, unidad_id: e.target.value })}>
                          <option value="">Filtrar por Unidad</option>
                          {filterOptions.unidadOptions.map(unidad => (
                              <option key={unidad.id} value={unidad.id}>{unidad.descripcion}</option>
                          ))}
                      </Form.Select>
                  </Col>
                  <Col>
                      <Form.Select
                      name='modalidad_id'
                      value={filtrosCurso.modalidad_id}
                        onChange={(e) => setFiltrosCurso({ ...filtrosCurso, modalidad_id: e.target.value })}>
                          <option value="">Filtrar por Modalidad</option>
                          {filterOptions.modalidadOptions.map(mod => (
                              <option key={mod.id} value={mod.id}>{mod.descripcion}</option>
                          ))}
                      </Form.Select>
                  </Col>
              </Row>
              <Row>
                  <Col>
                      <Form.Select 
                      name='nivel_id'
                      value={filtrosCurso.nivel_id}
                      onChange={(e) => setFiltrosCurso({ ...filtrosCurso, nivel_id: e.target.value })}>
                          <option value="">Filtrar por Nivel</option>
                          {filterOptions.nivelOptions.map(nivel => (
                              <option key={nivel.id} value={nivel.id}>{nivel.descripcion}</option>
                          ))}
                      </Form.Select>
                  </Col>
                  {/* <Col>
                      <Form.Select 
                      name='grupo'
                      value={filtrosCurso.grupo}
                      onChange={(e) => setFiltrosCurso({ ...filtrosCurso, grupo: e.target.value })}>
                          <option value="">Filtrar por Grupo</option>
                          {filterOptions.grupoOptions.map(grupo => (
                              <option key={grupo.id} value={grupo.id}>{grupo.descripcion}</option>
                          ))}
                      </Form.Select>
                  </Col> */}
                  
              </Row>

              <Table striped bordered hover className='mt-3'>
                  <thead>
                      <tr>
                          <th>COD</th>
                          <th>Descripción</th>
                          <th>Horas</th>
                          <th>Acciones</th>
                      </tr>
                  </thead>
                  <tbody>
                      {paginatedCursos.map((curso) => (
                          <tr key={curso.id}>
                              <td>{curso.cod}</td>
                              <td>{curso.curso_descripcion}</td>
                              <td>{curso.cantidad_horas}</td>
                              <td>
                                  <div className="d-flex justify-content-center align-items-center">
                                      <Button variant="info" onClick={() => handleSeleccionarCurso(curso)} className="me-2">
                                          <i className="bi bi-check2-square"></i>
                                      </Button>
                                  </div>
                              </td>
                          </tr>
                      ))}
                  </tbody>
              </Table>

          </Modal.Body>
          <Modal.Footer>
              
              <Button
                  variant="secondary"
                  onClick={() => handleCursosPageChange(currentPageCursos - 1)}
                  disabled={currentPageCursos === 1}
              >
                  Anterior
              </Button>
              <Button
                  variant="secondary"
                  onClick={() => handleCursosPageChange(currentPageCursos + 1)}
                  disabled={currentPageCursos === totalPages}
              >
                  Siguiente
              </Button>
              
              <Button variant="secondary" onClick={() => setShowCursoModal(false)}>
                  Cerrar
              </Button>
          </Modal.Footer>
      </Modal>

    </div>
    </div>
    </div>
  );
};

export default CreateCursos;
